import { render, staticRenderFns } from "./AliOssUploader.vue?vue&type=template&id=88c951fc&scoped=true&"
import script from "./AliOssUploader.vue?vue&type=script&lang=js&"
export * from "./AliOssUploader.vue?vue&type=script&lang=js&"
import style0 from "./AliOssUploader.vue?vue&type=style&index=0&id=88c951fc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c951fc",
  null
  
)

export default component.exports